import { ScanBarcode } from "lucide-react";

import { avisoDoCodigo } from "./codigoBarras";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

const COR_DO_AVISO = {
  ok: "text-emerald-600 dark:text-emerald-400",
  neutro: "text-muted-foreground",
  alerta: "text-amber-600 dark:text-amber-400",
  erro: "text-red-600 dark:text-red-400",
};

/** Campo "Código de barras" do cadastro de produto (Cardápio → Produtos → Editar).
 *  Aceita digitar os números da embalagem ou clicar e bipar com o leitor USB. */
export default function CampoCodigoBarras({ value, onChange, id = "barcode-main" }) {
  const aviso = avisoDoCodigo(value);

  // O leitor USB "digita" o código e aperta Enter no fim. Dentro do formulário
  // do produto esse Enter salvava o produto na hora da leitura.
  const segurarEnter = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  return (
    <div>
      <Label htmlFor={id} className="text-[10px] text-muted-foreground uppercase tracking-wider font-bold">
        Código de barras
      </Label>
      <div className="relative mt-1.5">
        <ScanBarcode className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" />
        <Input
          id={id}
          data-testid="product-barcode-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={segurarEnter}
          placeholder="Bipe com o leitor ou digite os números"
          autoComplete="off"
          spellCheck={false}
          maxLength={60}
          className="h-10 pl-9 font-mono tracking-wide"
        />
      </div>
      <p className={`text-[11px] mt-1 ${aviso ? COR_DO_AVISO[aviso.tom] : "text-muted-foreground"}`}>
        {aviso ? aviso.texto : "Opcional. Um código só pode estar em um produto."}
      </p>
    </div>
  );
}
